import { gql } from 'graphql-tag'

export const activityWeightFragment = gql`
  fragment ActivityWeightFragment on ActivityWeight {
    activity
    weightPercentage
  }
`

export const fetchActivityWeights = gql`
  query FetchActivityWeights($stationId: ID!, $type: String!) {
    activityWeights(stationId: $stationId, type: $type) {
      ...ActivityWeightFragment
    }
  }
  ${activityWeightFragment}
`

export const upsertActivityWeightsMutation = gql`
  mutation UpsertActivityWeights($stationId: ID!, $data: [ActivityWeightInput]!, $type: String!) {
    upsertActivityWeights(stationId: $stationId, data: $data, type: $type) {
      ...ActivityWeightFragment
    }
  }
  ${activityWeightFragment}
`
